import React, { useEffect } from 'react';
import MainPanel from '../../components/kick-counter/main-panel/MainPanel';
import SecondaryPanel from '../../components/kick-counter/secondary-panel/SecondaryPanel';
import styles from './KickCounter.module.css';

export default function KickCounter() {
  useEffect(() => {
    document.body.style.backgroundColor = 'white';
  }, []);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.gridContainer}>
        <MainPanel />
        <SecondaryPanel />
      </div>
    </div>
  );
}
